var React = require('react');

function ArrowAltCircleRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm134.48 256.52L276.32 380.41c-7.49 7.67-20.48 2.22-20.48-8.57v-71.51H140a12.08 12.08 0 0 1-12-12.1v-64.56a12.08 12.08 0 0 1 12-12.1h115.84v-71.41c0-10.79 12.89-16.24 20.48-8.57l114.16 115.89a12.08 12.08 0 0 1 0 17.04z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M128 288.23v-64.56a12.08 12.08 0 0 1 12-12.1h115.84v-71.41c0-10.79 12.89-16.24 20.48-8.57l114.16 115.89a12.08 12.08 0 0 1 0 17L276.32 380.41c-7.49 7.67-20.48 2.22-20.48-8.57v-71.51H140a12.08 12.08 0 0 1-12-12.1z","className":"fa-primary","key":2})]);
}

ArrowAltCircleRight.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ArrowAltCircleRight;

ArrowAltCircleRight.default = ArrowAltCircleRight;
